import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import ModalComponent from '@components/modal/Modal.component';

import SelectComponent from '@components/inputs/select/Select.component';
import {IssuesGroupedAction, issuesService, IssueStatus} from '@store/operations/issues';

interface IssueGroupedActionModalProps {
  handleClose: () => void;
}

const IssueGroupedActionModal = (props: IssueGroupedActionModalProps) => {
  const {handleClose} = props;

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IssuesGroupedAction>({});

  const updateData = (newData: IssuesGroupedAction) => setData((state) => ({...state, ...newData}));

  const handleSave = () => {
    setLoading(true);
    issuesService.issuesGroupedAction(data).pipe(finalize(() => setLoading(false))).subscribe({
      next: (ids) => {
        enqueueSnackbar(t('operations.nonCompliance.success.update', {count: ids.length}), {variant: 'success'});
        handleClose();
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  const disabled = !data.status;

  return (
    <ModalComponent
      title={t('global.groupedAction')}
      handleClose={handleClose}
      content={(
        <Stack width="70%" spacing={2} pt="55px" pb="10px">
          <SelectComponent
            color="secondary"
            labelWidth={160}
            label={t('global.status')}
            placeholder={t('global.selectOption')}
            handleChange={(status) => updateData({status})}
            value={data.status}
            items={IssueStatus.selectItems()}/>
        </Stack>
      )}
      actions={(
        <Button variant="contained" disabled={loading || disabled} onClick={handleSave} color="primary">
          {t('global.save')}
        </Button>
      )}/>
  );
};

export default IssueGroupedActionModal;